import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";

export const FIELDS = [
  { id: "account", label: "Account" },
  // { id: "competitiveReplacement", label: "Comp. Repl.", title: "Competitive Replacement" },
  { id: "onsite", label: "On Site" },
  { id: "onsiteDetail", label: "With Customer?", title: "How the employee was with a customer. Hidden for CAE regardless of this setting", },
  { id: "location", label: "Location" },
  { id: "productGroup", label: "Product Group" },
  { id: "productLine", label: "Product Line" },
  { id: "distributor", label: "Distributor" },
  { id: "opportunity", label: "Opportunity" },
  { id: "serviceRequest", label: "Service Request" },
  { id: "interlock", label: "Interlock" },
];

const NIL_FIELDS = [
  "onsite",
  "onsiteDetail",
];

/**
 * @param {?object} category
 * @param {object[]} category.fields
 * @param {object} user
 * @param {string} user.timeTrackingRole
 * @return {object}
 */
export function calculateCategoryFieldsFor(category, user) {
  const fields = {
    account: "optional",
    competitiveReplacement: "optional",
    onsite: "optional",
    onsiteDetail: "optional",
    location: "optional",
    productGroup: "optional",
    distributor: "optional",
    opportunity: "optional",
    serviceRequest: "optional",
    interlock: "optional"
  };

  for (const field of categoryFieldsFor(category)) {
    fields[field.id] = field.required;
  }

  if (fields.onsiteDetail !== "hidden") {
    if (hideOnsiteDetailForUser(user)) {
      fields.onsiteDetail = "hidden";
    }
  }

  // temporarily enforce hidden field for competitiveReplacement
  fields.competitiveReplacement = "hidden";

  if (process.env.NODE_ENV === "development") {
    console.info("calculateCategoryFieldsFor");
    console.dir({ user, fields });
  }

  return fields;
}

/**
 * @param {object} field
 * @param {string} field.id
 * @param {string, boolean} field.required
 * @param {object} entry
 * @return {boolean}
 */
export function shouldAddRequiredField(field, entry) {
  if (!(field.required === "required" || field.required === true)) {
    return false;
  }

  const { id: fieldId } = field;
  const value = get(entry, fieldId);

  return shouldAddRequiredFieldByValue(fieldId, value);
}

/**
 * @param {?object} category
 * @param {?object[]} category.fields
 * @return {object[]}
 */
function categoryFieldsFor(category) {
  return get(category, "fields", []);
}

/**
 * @param {object} user
 * @param {string} user.timeTrackingRole
 * @return {boolean}
 */
function hideOnsiteDetailForUser(user) {
  return get(user, "timeTrackingRole") === "CAE";
}

/**
 * @param {string} fieldId
 * @param {object} value
 * @return {boolean}
 */
function shouldAddRequiredFieldByValue(fieldId, value) {
  if (NIL_FIELDS.includes(fieldId)) {
    return isNil(value);
  } else {
    return isEmpty(value);
  }
}



// WEBPACK FOOTER //
// ./app/utils/category-fields.js